import styles from './style.postcss';

import React, { PureComponent } from 'react';

import {
  AttendanceStatusColorMappings,
  DefaultAttendanceStatus,
  validateAttendanceStatus,
} from 'data/SessionsAttendance/status';
import { testClass, StudentCard, Icon, connect, PrivilegeChecker } from 'omni-common-ui';
import classnames from 'classnames';
import MarkAttendanceButtons from '../../MarkAttendanceButtons/component';
import { parseProductionStatus } from 'domain/ProductionStatus';
import PropTypes from 'prop-types';
import StudentCardProfile from 'containers/StudentCardProfile';
import NewNotePopup from 'components/NewNotePopup';
import Privileges from 'domain/Privileges';
import { actions as notesActions } from 'containers/Student/Note';
import { bindActionCreators } from 'redux';
import QuickSummary from 'components/QuickSummary';

export class Student extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { dialogOpen: false };
    this._onSaveNoteClicked = this._onSaveNoteClicked.bind(this);
    this._onOpenDialogClicked = this._onOpenDialogClicked.bind(this);
    this._onCancelDialogClicked = this._onCancelDialogClicked.bind(this);
  }

  _onSaveNoteClicked(note) {
    this.props.submitStudentNote(this.props.studentId, {
      groupId: this.props.groupId,
      category: notesActions.STUDENT_NOTE_CATEGORY_ATTENDANCE,
      content: note,
      entityId: this.props.sessionId,
    });
    this.setState({ dialogOpen: false });
  }

  _onOpenDialogClicked() {
    this.setState({ dialogOpen: true });
  }

  _onCancelDialogClicked() {
    this.setState({ dialogOpen: false });
  }

  _renderStatus() {
    const className = classnames(styles.Student_attendanceStatusText,
      testClass('student-attendance-status'));
    if (this.props.marking) {
      return <MarkAttendanceButtons status={this.props.status}
          onMarkPresent={this.props.onMarkPresent}
          onMarkAbsent={this.props.onMarkAbsent}
          onMarkLate={this.props.onMarkLate} />;
    }
    return <p className={className}>{this.props.status}</p>;
  }

  render() {
    const status = this.props.status || DefaultAttendanceStatus;
    validateAttendanceStatus(status);

    const productionStatus = parseProductionStatus(this.props.productionStatus);
    return <StudentCard withSeparatorLine={! this.props.marking}
        statusAccentColor={this.props.marking ? undefined : AttendanceStatusColorMappings[status]}
        className={testClass('attendance-studentCard')}>
      <div className={styles.Student_wrapper}>
        {
          this.state.dialogOpen &&
          <NewNotePopup titleGroup={this.props.groupNumber}
              studentName={`${this.props.name} ${this.props.surname}`}
              extraInfo={<QuickSummary type={QuickSummary.Type.attendance}
                  entityId={this.props.sessionId} />}
              onSave={this._onSaveNoteClicked}
              onCancel={this._onCancelDialogClicked}
              category="Behaviour &amp; Participation" />
        }
        <div className={styles.Student_student}>
          <StudentCardProfile studentId={this.props.studentId}
              status={productionStatus.fullName}
              statusHighlighted={this.props.isInProduction} />
        </div>
        {
          this.props.canAddStudentNotes &&
          <div className={styles.Student_icon} onClick={this._onOpenDialogClicked}>
            <Icon id="new-message" />
          </div>
        }
      </div>
      <StudentCard.Content>
        {this._renderStatus()}
      </StudentCard.Content>
    </StudentCard>;
  }
}

Student.propTypes = {
  status: PropTypes.string,
  name: PropTypes.string,
  surname: PropTypes.string,
  localname: PropTypes.string,
  avatarUrl: PropTypes.string,
  gender: PropTypes.string,
  marking: PropTypes.bool,
  onMarkPresent: PropTypes.func,
  onMarkAbsent: PropTypes.func,
  onMarkLate: PropTypes.func,
  productionStatus: PropTypes.string,
  isInProduction: PropTypes.bool,
  studentId: PropTypes.string,
  groupNumber: PropTypes.string,
  sessionInfo: PropTypes.string,
  canAddStudentNotes: PropTypes.bool,
  submitStudentNote: PropTypes.func.isRequired,
  groupId: PropTypes.string.isRequired,
  sessionId: PropTypes.string.isRequired,
};

export function mapStateToProps(state) {
  const canAddStudentNotes =
      PrivilegeChecker.hasPrivilege(state, Privileges.AcademicInfo.AddStudentNotes);

  return {
    canAddStudentNotes,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(notesActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Student);



// WEBPACK FOOTER //
// ./containers/Group/Attendance/MarkAttendance/MarkAttendanceDayView/Student/student.jsx